import FeatureCard from "@/components/site/FeatureCard";
import Reveal from "@/components/site/Reveal";
import SectionTitle from "@/components/site/SectionTitle";

/** Modules réellement disponibles dans l'application (une ligne = une action qu'on fait vraiment). */
const modules = [
  {
    icon: "ri-user-add-line",
    title: "Élèves et inscriptions",
    items: [
      "Inscription et réinscription en quelques étapes",
      "Dossier de l'élève et de ses parents",
      "Photo prise directement à la caméra",
      "Cartes scolaires et certificats",
      "Départ d'un élève sans perdre son historique",
    ],
  },
  {
    icon: "ri-edit-box-line",
    title: "Notes et bulletins",
    items: [
      "Une évaluation pour toute la classe",
      "Saisie par matière, par l'enseignant",
      "Moyennes, rangs et mentions calculés",
      "Bulletin par évaluation ou par trimestre",
      "Liste par ordre de mérite",
    ],
  },
  {
    icon: "ri-wallet-3-line",
    title: "Frais et paiements",
    highlight: true,
    items: [
      "Fiche des frais par classe, en tranches",
      "On coche les frais que le parent paie",
      "Reçu numéroté en PDF à chaque paiement",
      "Ce que chaque élève a payé et doit encore",
      "Annulation d'un reçu avec son motif",
    ],
  },
  {
    icon: "ri-alarm-warning-line",
    title: "Impayés et relances",
    items: [
      "Les retards par classe et par tranche",
      "Avis de paiement à remettre aux parents",
      "Chaque relance est notée",
      "Les élèves partis restent visibles",
    ],
  },
  {
    icon: "ri-line-chart-line",
    title: "Recettes et dépenses",
    items: [
      "Recettes et dépenses par cycle",
      "Budget prévu, mois par mois",
      "Prévision de trésorerie",
      "Rapports sur la période choisie",
    ],
  },
  {
    icon: "ri-safe-2-line",
    title: "Caisse et clôtures",
    items: [
      "Caisse du jour par caissier et par mode",
      "Comptage des billets et écart",
      "Journée validée, puis figée",
      "Clôture du mois",
    ],
  },
  {
    icon: "ri-team-line",
    title: "Personnel et paie",
    items: [
      "Fiches du personnel et des enseignants",
      "Salaire fixe ou heures × tarif horaire",
      "Toute la paie du mois en une fois",
      "Fiches de paie en PDF",
    ],
  },
  {
    icon: "ri-shield-user-line",
    title: "Comptes et sécurité",
    items: [
      "Rôles et droits choisis case par case",
      "Accès limité au Primaire ou au Secondaire",
      "Journal de chaque action",
      "Alertes dans la cloche",
    ],
  },
];

export default function FeaturesSection() {
  return (
    <section id="fonctionnalites" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionTitle
            eyebrow="Modules"
            title="Ce que fait l'application, concrètement"
            intro="Tout est inclus dans le forfait Établissement. Le forfait Essentiel garde les élèves, les notes, les paiements et les relances."
          />
          <p className="max-w-xs text-sm leading-relaxed text-foreground-600 md:text-right">
            Pas d'installation : tout se passe dans le navigateur, sur ordinateur comme sur téléphone.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {modules.map((m, index) => (
            <Reveal key={m.title} delay={(index % 4) * 70} className="h-full">
              <FeatureCard icon={m.icon} title={m.title} items={m.items} highlight={m.highlight} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
